export const chefPicks = [
  {
    id: "queso-alga-nori",
    name: "Sando Queso con Alga Nori",
    price: "$32.000",
    tag: "El clásico de la casa",
    description:
      "Ajonjolí, miel, tocino, pan de leche, cebolla de Granja la Arandela y mayonesa.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photography%20of%20a%20Japanese%20sando%20sandwich%20on%20fluffy%20milk%20bread%20filled%20with%20melted%20cheese%2C%20nori%20seaweed%2C%20sesame%20seeds%2C%20honey%20and%20crispy%20bacon%2C%20cut%20in%20half%20showing%20layers%2C%20warm%20cream%20beige%20seamless%20studio%20background%2C%20soft%20diffused%20natural%20light%2C%20minimal%20contemporary%20japanese%20aesthetic%2C%20high%20detail%2C%20appetizing&width=900&height=900&seq=sando-queso-nori&orientation=squarish",
  },
  {
    id: "solomo",
    name: "Sando de Solomo 120 g",
    price: "$40.000",
    tag: "El favorito",
    description:
      "Con lechuga de Granja la Arandela, queso, tocino, miel mostaza, mayonesa y BBQ.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photography%20of%20a%20Japanese%20sando%20sandwich%20on%20fluffy%20milk%20bread%20with%20sliced%20beef%20tenderloin%2C%20lettuce%2C%20cheese%2C%20bacon%2C%20honey%20mustard%20mayo%20and%20BBQ%20sauce%2C%20cut%20showing%20juicy%20layers%2C%20warm%20cream%20beige%20seamless%20background%2C%20soft%20natural%20studio%20light%2C%20minimal%20japanese%20aesthetic%2C%20high%20detail&width=900&height=900&seq=sando-solomo&orientation=squarish",
  },
  {
    id: "pollo",
    name: "Sando de Pollo 150 g",
    price: "$30.000",
    tag: "",
    description:
      "Trozo de pechuga apanada, con lechuga de Granja la Arandela, tocino, queso, miel, mayonesa y BBQ.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photography%20of%20a%20Japanese%20katsu%20sando%20with%20crispy%20breaded%20chicken%20breast%2C%20lettuce%2C%20bacon%2C%20cheese%2C%20honey%20mayo%20and%20BBQ%20sauce%2C%20on%20fluffy%20milk%20bread%2C%20warm%20cream%20beige%20seamless%20background%2C%20soft%20natural%20light%2C%20minimal%20japanese%20aesthetic%2C%20high%20detail&width=900&height=900&seq=sando-pollo&orientation=squarish",
  },
  {
    id: "cerdo",
    name: "Sando de Cerdo 120 g",
    price: "$30.000",
    tag: "Ahumado",
    description:
      "Cerdo ahumado, con lechuga de Granja la Arandela, tocino, queso, miel, mayonesa y BBQ.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photography%20of%20a%20Japanese%20sando%20sandwich%20with%20smoked%20pork%2C%20lettuce%2C%20bacon%2C%20melted%20cheese%2C%20honey%20mayo%20and%20BBQ%20sauce%20on%20milk%20bread%2C%20warm%20cream%20beige%20seamless%20background%2C%20soft%20natural%20light%2C%20minimal%20contemporary%20japanese%20aesthetic%2C%20high%20detail&width=900&height=900&seq=sando-cerdo&orientation=squarish",
  },
  {
    id: "shokupan",
    name: "Shokupan",
    price: "$32.000",
    tag: "Postre",
    description:
      "Pan de leche, crema de chocolate, dulce de leche, ajonjolí, queso crema, cristales de sal.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photography%20of%20a%20Japanese%20sweet%20shokupan%20milk%20bread%20dessert%20sandwich%20filled%20with%20chocolate%20cream%2C%20dulce%20de%20leche%2C%20sesame%20seeds%2C%20cream%20cheese%20and%20salt%20crystals%2C%20warm%20cream%20beige%20seamless%20background%2C%20soft%20natural%20light%2C%20minimal%20japanese%20dessert%20aesthetic%2C%20high%20detail&width=900&height=900&seq=sando-shokupan&orientation=squarish",
  },
];

export const papasAddition = {
  name: "Adición de papas",
  price: "$6.000",
};

export const combos = [
  {
    id: "combo-1",
    name: "Combo 1",
    includes: "Sando + bebida + domicilio incluido",
    price: "Precio por confirmar",
  },
  {
    id: "combo-2",
    name: "Combo 2",
    includes: "Sando + acompañante + bebida + domicilio incluido",
    price: "Precio por confirmar",
  },
  {
    id: "combo-3",
    name: "Combo 3",
    includes: "Selección de dos sandos + bebidas + domicilio incluido",
    price: "Precio por confirmar",
  },
];

export const whySando = [
  {
    id: "pan",
    icon: "ri-restaurant-2-line",
    title: "El pan es el protagonista",
    text: "Pan de leche esponjoso y suave, horneado para esta carta.",
  },
  {
    id: "granja",
    icon: "ri-leaf-line",
    title: "Producto de granja",
    text: "Vegetales frescos de Granja la Arandela y encurtidos preparados por la chef.",
  },
  {
    id: "autor",
    icon: "ri-award-line",
    title: "Cocina de autor",
    text: "Firmado por Diana Cerón, del restaurante Cerón.",
  },
  {
    id: "sabores",
    icon: "ri-fire-line",
    title: "Una explosión de sabores",
    text: "Quesos que funden, ahumados y toques orientales en cada mordida.",
  },
];

export const orderSteps = [
  {
    id: "paso-1",
    number: "01",
    title: "Escríbenos por WhatsApp",
    text: "Toca el botón y nos cuentas qué quieres.",
  },
  {
    id: "paso-2",
    number: "02",
    title: "Confirmamos tu pedido",
    text: "Te decimos el total y el tiempo de entrega.",
  },
  {
    id: "paso-3",
    number: "03",
    title: "Llega a tu puerta",
    text: "Lo preparamos al momento y te lo llevamos.",
  },
];

export const gallery = [
  {
    id: "gal-1",
    alt: "Sando cortado a la mitad mostrando sus capas de cerdo ahumado, queso y lechuga",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photography%20of%20a%20halved%20japanese%20sando%20sandwich%20standing%20upright%20revealing%20juicy%20layers%20of%20smoked%20pork%20melted%20cheese%20lettuce%20and%20honey%20mayo%20between%20soft%20milk%20bread%2C%20warm%20sand%20beige%20seamless%20studio%20background%2C%20soft%20diffused%20natural%20light%2C%20minimal%20contemporary%20japanese%20aesthetic%2C%20generous%20negative%20space%2C%20high%20detail&width=700&height=700&seq=sando-gal-1&orientation=squarish&nocache=true",
  },
  {
    id: "gal-2",
    alt: "Dos mitades de sando de pollo apanado en un plato con salsa y ajonjolí",
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20editorial%20photograph%20of%20two%20japanese%20sando%20halves%20on%20a%20light%20ceramic%20plate%20beside%20a%20small%20bowl%20of%20dipping%20sauce%2C%20fluffy%20milk%20bread%20with%20crispy%20breaded%20chicken%20pickled%20vegetables%20and%20sesame%2C%20warm%20sand%20beige%20seamless%20background%2C%20soft%20natural%20window%20light%2C%20minimal%20japanese%20cafe%20aesthetic%2C%20high%20detail&width=700&height=700&seq=sando-gal-2&orientation=squarish&nocache=true",
  },
  {
    id: "gal-3",
    alt: "Manos de la chef cortando un sando sobre tabla de madera",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20close%20up%20of%20hands%20slicing%20a%20japanese%20sando%20sandwich%20on%20a%20wooden%20board%20with%20a%20chef%20knife%2C%20melted%20cheese%20stretching%20between%20the%20layers%2C%20warm%20sand%20beige%20background%2C%20soft%20diffused%20natural%20light%2C%20minimal%20contemporary%20japanese%20food%20aesthetic%2C%20generous%20negative%20space%2C%20high%20detail&width=700&height=700&seq=sando-gal-3&orientation=squarish&nocache=true",
  },
  {
    id: "gal-4",
    alt: "Tres sandos japoneses alineados mostrando distintos rellenos",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photography%20of%20three%20assorted%20japanese%20sandos%20lined%20up%20diagonally%20on%20a%20warm%20sand%20beige%20surface%2C%20each%20cut%20in%20half%20showing%20different%20fillings%20of%20melted%20cheese%20beef%20and%20smoked%20pork%2C%20scattered%20sesame%20seeds%2C%20soft%20natural%20light%2C%20minimal%20japanese%20aesthetic%2C%20high%20detail&width=700&height=700&seq=sando-gal-4&orientation=squarish&nocache=true",
  },
];

export const whyVideoPoster =
  "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20chef%20hands%20slicing%20a%20japanese%20sando%20sandwich%20on%20fluffy%20milk%20bread%20in%20a%20warm%20cream%20colored%20kitchen%2C%20soft%20natural%20window%20light%2C%20minimal%20contemporary%20japanese%20aesthetic%2C%20generous%20negative%20space%2C%20high%20detail&width=1600&height=900&seq=sando-craft-video&orientation=landscape";

export const heroFallbackImage =
  "https://storage.helloreaddy.io/project_files/b9287f61-0157-49b8-8c9e-4c9d0009a0af/b38217d4-3f9d-4f44-ba24-483120a4f5a8_compressed_Untitled-design-2.webp";